<template>
	<v-popover
		trigger="click"
		ref="popover"
		popover-base-class="tooltip tooltip-wide"
		popover-class="light no-arrow"
		:auto-hide="autoHide"
		:popper-options="popperOptions"
		offset="0"
		:placement="placement"
		class="dropdown-button-container"
		:delay="{ show: 0, hide: 0 }"
	>
		<button
			class="button w-size-small dropdown-button"
			:class="type"
			type="button"
			@click="clicked($event)"
			ref="element"
		>
			<slot></slot>
		</button>

		<div slot="popover" class="button-dropdown-actions" :class="disabled ? 'disabled' : ''" @click="clickedInside($event)" ref="actions" v-tooltip="disabled ? trans('misc.bulk_actions_disabled') : null">
			<slot name="actions"></slot>

			<div class="bottom-buttons" v-if="showBottomButtons">
				<button @click="clear">{{ trans("actions.clear") }}</button>
				<button @click="close">{{ trans("actions.close") }}</button>
			</div>
		</div>
	</v-popover>
</template>

<script type="text/babel">
export default {
	props: {
		method: { default: "button" }, // button, submit
		extraClasses: { default: "" },
		type: { default: "outline white dark-gray" }, // regular, outline, outline gray, white, danger, text-only, modern
		variant: { default: "normal" }, // normal, cta
		widthSize: { default: "normal" },
		isLoading: { default: false },
		isFull: { default: false },
		showBottomButtons: { default: false },
		prevent: { default: true },
		autoHide: { default: true },
		disabled: { default: false },
		hideOnTargetClick: { default: true },
		closeOnClickInside: { default: true },
		placement: { default: "bottom-end" },
	},

	computed: {
		popperOptions() {
			return { hideOnTargetClick: this.hideOnTargetClick, defaultAutoHide: this.autoHide };
		},
	},

	methods: {
		clickedInside(event) {
			if (
				this.closeOnClickInside &&
				event.target !== this.$refs.actions &&
				event.target.tagName.toLowerCase() !== "ul"
			) {
				this.$nextTick(() => {
					this.$refs.popover.hide();
				});
			}
		},

		clear(event) {
			this.$emit("clear");
		},

		close(event) {
			this.$refs.popover.hide();
		},

		clicked(event) {
			if (this.prevent) {
				event.preventDefault();
			}

			this.$emit("clicked");
			this.$emit("click");
		},
	},
};
</script>

<style>
.button-dropdown-actions.disabled ul li button {
  color: grey;
}
</style>